module.exports = "/logo_gfw_forest_watcher.png?63acfa";